import { Location, CommonModule } from '@angular/common';
import { HttpParams } from '@angular/common/http';
import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { ReactiveFormsModule, FormsModule, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { ImageCroppedEvent } from 'ngx-image-cropper';
import { Observable, Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppSettings } from 'src/app/services/AppSettings';
import { FormValidation } from 'src/app/services/FormValidation';
import { ApiService } from 'src/app/services/api.service';
import { candidateModel } from 'src/app/services/candidateModel';
import { CommonValues } from 'src/app/services/commonValues';
import { GigsumoService } from 'src/app/services/gigsumoService';
import { JobService } from 'src/app/services/job.service';
import { SearchData } from 'src/app/services/searchData';
import { WorkExperience } from 'src/app/services/userModel';
import { UtilService } from 'src/app/services/util.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import { PricePlanService } from '../../Price-subscritions/priceplanService';
import { CandidateTemplateComponent } from '../../candidate-template/candidate-template.component';
import { GigsumoConstants } from 'src/app/services/GigsumoConstants';
import { NgxSummernoteModule } from 'ngx-summernote';
import { ImageCropperModule } from 'ngx-image-cropper';
import { ConnectionTemplateComponent } from '../../../templates/connection-template/connection-template.component';
import { NewJobComponent } from '../../../page/homepage/layout-jobs/new-job/new-job.component';
import { TimezoneDatePipe } from '../../../timezone-date.pipe';
import { CandidatesProfileDetailsComponent } from '../candidates-profile-details/candidates-profile-details.component';
import { DndDirective } from 'src/app/directives/dnd.directive';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';
import { SpliterPipe } from 'src/app/spliter.pipe';
import { CompactCountPipe } from '../../../pipe/compact-count.pipe';


declare var $: any;
@Component({
  selector: 'app-candidate-profile-summary',
  standalone: true,
  imports: [
    CompactCountPipe,
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
NgxSummernoteModule,
    CandidateTemplateComponent,
    ImageCropperModule,
    ConnectionTemplateComponent,
    NewJobComponent,
    TimezoneDatePipe,
    CandidatesProfileDetailsComponent,
    DndDirective
  ,
    NG_ICON_DIRECTIVES,
    SpliterPipe,
  ],
  templateUrl: './candidate-profile-summary.component.html',
  styleUrls: ['./candidate-profile-summary.component.scss'],
  outputs: ['candidateListing'],
  inputs: ['candidateDetails', 'designVersion']
})
export class CandidateProfileSummaryComponent extends FormValidation implements OnInit, OnChanges {
  candidateId: any;
  candidateDetails: candidateModel;
  designVersion: string;
  private destroy$ = new Subject<void>();
  @Input() isInSlider: boolean = false;
  @Input() jobId: string; // For showing job-specific details
  jobSpecificDetails: any = null; // Holds the job's specific application data
  rateLabel: string = 'Submitted for';
  @Input() passValues: Array<candidateModel> = [];
  userId: string = localStorage.getItem('userId');
  @ViewChild("myFileInput") myFileInput;
  @ViewChild("myFileInput1") myFileInput1;
  @ViewChild("myFileInput2") myFileInput2;
  @ViewChild('jobsupplytemplate') jobsupplyTemplateRef: TemplateRef<any>;
  @ViewChild('template') resumeUploadTemplateRef: TemplateRef<any>;
  imageChangedEvent: any = "";
  candidateListing = new EventEmitter();
  public FORMERROR = super.Form;
  fileUploadName;
  fileshow = undefined;
  fileToUpload: File;
  photoId: any = null;
  FormData: any;
  bsModalRef: BsModalRef;
  infoData: any = {};
  photo: any = null;
  submited: boolean = false;
  showmodel = false;
  showAllPrimarySkills: boolean = false;
  showAllSecondarySkills: boolean = false;

  firstName: any;
  candidateSupplyRef: BsModalRef;
  fileSize = AppSettings.FILE_SIZE;
  lastName: any;

  currentTimeDate: string | Date;
  connectionStatus: string;
  connectionRequestRef: BsModalRef;
  values: any;
  counterpartsDetails: any;
  unit = { duration: '30' };

  primaryEmail: any;
  selectedJobTitle: string;
  updateDate: any = [];
  url = AppSettings.ServerUrl + "download/";

  userType = localStorage.getItem('userType');
  public envName: any = environment.name;
  tempFile: File;
  object: any;
  years: any = []
  config2 = {
    focus: false,
    height: 150,
    placeholder: "",
    link: [["link", ["linkDialogShow", "unlink"]]],
    insert: ["link", "picture", "video"],
    view: ["fullscreen", "codeview", "help"],
    style:
      "outline: none !important;background-color: rgb(241 243 246) !important;cursor: pointer !important;",
    disableDragAndDrop: true,
    blockquoteBreakingLevel: 1,
    callbacks: {
      onFocus: function (contents) {
        if ($(this).summernote("isEmpty")) {
          $("#summessage").html(""); //either the class (.) or id (#) of your textarea or summernote element
        }
      },
    },
    toolbar: [
      ["misc", ["codeview", "undo", "redo"]],
      // ['style', ['bold', 'italic', 'underline', 'clear']],
      [
        "font",
        [
          "bold",
          "italic",
          "underline",
          "strikethrough",
          "superscript",
          "subscript",
          "clear",
        ],
      ],
      ["fontsize", ["fontname", "fontsize", "color"]],
      ["para", ["style", "ul", "ol", "paragraph", "height"]],
    ],
    fontNames: [
      "Helvetica",
      "Arial",
      "Arial Black",
      "Comic Sans MS",
      "Courier New",
      "Roboto",
      "Times",
    ]
  };
  uploadFiles: Array<any> = [];
  resumeId;
  checkisDefault
  modalRef2: BsModalRef | null;
  img: any = {};
  img4: any = {};
  croppedImage: any = "";
  serverCurrentDate: string;
  servertimedate: string;
  disable_for_draft: boolean = false;
  resumeupload;
  // fileDragdrop: any;
  figureLength: number = 0;
  payType: null;
  typeTargetValue: string;
  targetRate: null;
  countryChosen: null;
  selectedCountries: boolean = false
  augmentedList
  fileName
  resumelist;
  resumelength

  primarySkillsSelected = [];
  secondarySkillsSelected = [];
  stateListCA: any = []
  stateListIN: any = []
  stateListAU: any = []
  countryList: any = [];
  submit: boolean = false
  organizationList: any = []
  primarySkillsList: any = []
  secondarySkillsList: any = []
  skillsList: any = []
  payTypeList: any = []
  clientTypeList: any = []
  clientNameList: any = []
  clientNameList1: any = []
  durationTypeList: any = []
  usStatesList = []
  jobClassificationList: any = []
  commonVariables: any = {};
  totalExperienceList = []
  periodList = []
  //effectiveforList = []
  recruiterTitleList: any = []
  engagementTypeList = []
  workAuthorizationList: any = []
  jobPostForm: UntypedFormGroup;
  currentTime: any;
  maxDate: any
  candidateSubmit: boolean = false


  candidatePostForm: UntypedFormGroup;
  backdropConfig = {
    backdrop: true,
    ignoreBackdropClick: true,
    keyboard: false,
    // scroll
  };
  candidateJobTitleList: any = []
  modalRef: BsModalRef;
  otherStatesList: any = []
  modalOpen: boolean = false
  toggleOpen: boolean = false;
  candidatelistsub: Subscription;
  currentOrganizationDetail: WorkExperience;
  Resurl: any = AppSettings.ServerUrl;
  @ViewChild("connectionTemplate") connectionTemplate: TemplateRef<any>;
  constructor(
    private api: ApiService,
    private router: Router,
    private _location: Location,
    private util: UtilService,
    private formBuilder: UntypedFormBuilder,
    private activatedRoute: ActivatedRoute,
    private modalService: BsModalService,
    private searchData: SearchData,
    private commonValues: CommonValues,
    private planService: PricePlanService,
    private JobServicecolor: JobService,
    public gigsumoService: GigsumoService
  ) {
    super();
    this.userId = localStorage.getItem('userId');


  }

  refresh:boolean=true;
  ngOnChanges(changes: SimpleChanges): void {
    // AUDIT_04 — removed the 1-second `refresh=false → setTimeout(…, 1000)`
    // remount cycle that hid `app-candidates-profile-details` on every
    // tab/candidate change. The child handles its own input swap via
    // `ngOnChanges`; a remount isn't necessary and produced a visible flash.
    if (changes.passValues && changes.passValues.currentValue != undefined) {
      this.passValues = changes.passValues.currentValue;
    }

    if (changes.candidateDetails && changes.candidateDetails.currentValue) {
      this.candidateDetails = changes.candidateDetails.currentValue;
      this.extractJobSpecificDetails();

      // Force toggle to sync with new candidate status
      // Fixes stale NgModel state after closing plan upgrade popup
      const toogleBar = document.getElementById('toogleBar') as HTMLInputElement;
      if (toogleBar) {
        toogleBar.checked = this.candidateDetails.status === 'ACTIVE';
      }
    }

    if (changes.jobId) {
      this.extractJobSpecificDetails();
    }
  }

  private extractJobSpecificDetails(): void {
    console.log('🔍 Extracting job-specific details...');
    console.log('  jobId:', this.jobId);
    console.log('  candidateDetails exists:', !!this.candidateDetails);
    console.log('  jobsApplied array:', this.candidateDetails?.jobsApplied);
    console.log('  targetFortheJob:', this.candidateDetails?.['targetFortheJob']);
    console.log('  payTypefortheJob:', this.candidateDetails?.['payTypefortheJob']);
    console.log('  isInSlider:', this.isInSlider);

    if (this.jobId && this.candidateDetails && this.candidateDetails.jobsApplied) {
      // Find the matching entry in jobsApplied array
      // Note: The property name is "userId" but it actually contains the JOB ID (confusing naming!)
      const matchedEntry = this.candidateDetails.jobsApplied.find(
        (application: any) => {
          console.log('  Checking application.userId:', application.userId, 'against jobId:', this.jobId);
          return application.userId === this.jobId;
        }
      );

      if (matchedEntry) {
        // jobsApplied entry already has targetRate and payType
        // Fall back to root-level targetFortheJob/payTypefortheJob if not present in the entry
        this.jobSpecificDetails = {
          ...matchedEntry,
          targetRate: matchedEntry.targetRate || this.candidateDetails['targetFortheJob'],
          payType: matchedEntry.payType || this.candidateDetails['payTypefortheJob']
        };
        console.log('  ✅ Match found and enriched with rate info:', this.jobSpecificDetails);
      } else if (this.candidateDetails['targetFortheJob']) {
        // No jobsApplied match but rate data exists (e.g. contract-candidates context)
        this.jobSpecificDetails = {
          targetRate: this.candidateDetails['targetFortheJob'],
          payType: this.candidateDetails['payTypefortheJob']
        };
        console.log('  ✅ No jobsApplied match but rate data found from contract context:', this.jobSpecificDetails);
      } else {
        this.jobSpecificDetails = null;
        console.log('  ❌ No matching job found in jobsApplied array');
      }
    } else if (this.candidateDetails && this.candidateDetails['targetFortheJob']) {
      // No jobsApplied array but rate data exists (e.g. contract-candidates context)
      this.jobSpecificDetails = {
        targetRate: this.candidateDetails['targetFortheJob'],
        payType: this.candidateDetails['payTypefortheJob']
      };
      console.log('  ✅ Rate data found from contract context (no jobsApplied):', this.jobSpecificDetails);
    } else {
      this.jobSpecificDetails = null;
      console.log('  ❌ Missing required data - jobSpecificDetails set to null');
    }
    // Show "Applied for" if candidate belongs to my business (contract center context)
    const myBusinessId = localStorage.getItem('myBusinessId');
    if (myBusinessId && this.candidateDetails?.['businessId'] === myBusinessId) {
      this.rateLabel = 'Applied for';
    } else {
      this.rateLabel = 'Submitted for';
    }
    console.log('  Final jobSpecificDetails:', this.jobSpecificDetails);
  }

countryDialCode:string;
  ngOnInit() {
    this.gigsumoService.loadMyBusinessId();
    this.countryDialCode = GigsumoConstants.getCountryDialCode(this.candidateDetails.country);
  }
  updateCandidateObject(candidateObject): void {
    if (this.candidateDetails.candidateId == candidateObject.candidateId) {
      this.candidateDetails.status = candidateObject.status
    }
  }
  ngOnDestroy() {
    if (this.candidatelistsub) {
      this.candidatelistsub.unsubscribe();
    }
    this.destroy$.next();
    this.destroy$.complete();
  }



  closemodel() {
    this.modalRef.hide();
  }


  async proceedToInvite(values, jobsupplytemplate) {
    try {
      this.util.startLoader();

      if (this.planService.ACTIVE_INTERACTION === 0) {
        let availablePoints = null;
        let actualPoints = null;
        let utilizedPoints = null;
        let promotional = null;
        const userData = await this.planService.UPDATE_USERDETAILS("ACTIVE_INTERACTIONS");
        let { membershipType } = userData;
        userData.userDetail.userPlanAndBenefits.benefitsUsages.forEach(ele => {
          if (ele.benefitKey == 'ACTIVE_INTERACTIONS') {
            availablePoints = ele.available
            actualPoints = ele.actual
            utilizedPoints = ele.utilized
            promotional = ele.promotional
          }
        })
        let popupType: "PAY" | "LIMIT" | "UPGRADE" = "PAY";

        if (['Starter', 'Growth', 'ScaleX'].includes(membershipType)) {
          popupType = "LIMIT";
        }
        this.planService.expiredPopup("ACTIVE_INTERACTIONS", popupType, null, null, null, null, availablePoints, actualPoints, utilizedPoints, promotional);
        this.util.stopLoader();
        return;
      }
      values.userId = localStorage.getItem('userId');
      values.candidatefilter = true;
      values.getResume = false;
      values.userType = values.user.userType;
      const config: ModalOptions = { class: 'modal-lg', backdrop: 'static', keyboard: false };
      setTimeout(() => {
        this.candidateSupplyRef = this.modalService.show(jobsupplytemplate, config);
      }, 500);

    } catch (error) {
      this.util.stopLoader();
    }
    finally {
      setTimeout(() => {
        this.util.stopLoader();
      }, 1000);
    }

  }


  connect(userId: string) {
    let datas: any = {};
    datas.userId = userId;
    datas.requestedBy = localStorage.getItem('userId');
    this.util.startLoader();
    this.api.create("user/connect", datas).pipe(takeUntil(this.destroy$)).subscribe((conData) => {
      this.util.stopLoader();
      console.warn("Connection Response data: ", conData);
      if (conData.code === "00000") {
        Swal.fire({
          icon: "success",
          title: "Connection request sent successfully",
          showConfirmButton: false,
          timer: 2000,
        });
      } else if (conData.code === "88888") {
        Swal.fire({
          position: "center",
          icon: "error",
          title: "Oops..",
          text: "Sorry, connection request failed. Please try after some time",
          showConfirmButton: false,
          timer: 3000,
        });

      }
    }, err => {
      this.util.stopLoader();
    });
  }



  checkConnectionStatus(values): Observable<any> {
    const apiURL = 'user/checkConnectionStatus';
    const params = new HttpParams()
      .set('userId', this.userId)
      .set('connnectorId', values.createdBy);

    const urlWithParams = `${apiURL}?${params.toString()}`;
    return this.api.query(urlWithParams);
  }
  focus: string;
  passCandidateData: any;
  invite(values: any, jobsupplytemplate: TemplateRef<any>, template: TemplateRef<any>) {
    this.focus = 'candidate'
    this.passCandidateData = values;
    if (values.isFeatured == true) {
      this.proceedToInvite(values, jobsupplytemplate);
    } else if (values.isFeatured == false || values.isFeatured == null) {
      if (values.connectionStatus === 'CONNECTED') {
        this.proceedToInvite(values, jobsupplytemplate);
      } else if (values.connectionStatus !== 'CONNECTED') {
        this.proceedToInvite(values, jobsupplytemplate);
        // to be used later
        // this.openConnectionTemplate(values.connectionStatus, values, template);
      }
    }
  }

  extractText(val: string) {
    return FormValidation.extractContent(val);
  }

  openConnectionTemplate(connectionStatus, values, connectionTempate?: TemplateRef<any>) {
    this.connectionStatus = connectionStatus;
    this.values = values;
    const config: ModalOptions = { class: 'modal-md', backdrop: 'static', keyboard: false };
    this.api.query("user/" + this.values.createdBy).pipe(takeUntil(this.destroy$)).subscribe(res => {
      if (res.code == '00000') {
        this.counterpartsDetails = res;
        this.connectionRequestRef = this.modalService.show(connectionTempate, config);
      }
    })
  }


  onDownload() {
    const file: File = this.tempFile;
    this.downloadFile(new Blob([file]), file.name);
  }

  downloadFile(blob: Blob, fileName: string): void {
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.append(link);
    link.click();
    link.remove();
    // in case the Blob uses a lot of memory
    setTimeout(() => URL.revokeObjectURL(link.href), 0);
  }

  close() {
    this.modalRef2.hide();
    this.resumeupload = "";
    this.fileDragdrop = "";
  }
  open(content, item) {
    this.util.startLoader();
    this.resumeId = item;
    let loading = true;
    this.api.query("candidates/findCandidateById/" + this.candidateDetails.candidateId).pipe(takeUntil(this.destroy$)).subscribe(
      (res) => {
        if (res.code == '00000') {
          this.util.stopLoader();
          this.resumelist = "";
          this.candidateDetails = res.data.candidateData;
          this.resumelist = res.data.candidateData.resumes;
          this.resumelength = res.data.candidateData.resumes;
          this.candidateDetails.photo = res.data.candidateData.photo;
          // this.candidateDetails.userTypenot = res.data.candidateData.user.userType;
          this.photoId = res.data.candidateData.photo;
          if (loading) {
            this.modalRef = this.modalService.show(content, this.backdropConfig);
          }
        }
        loading = false;
      },
      (error) => {
        this.util.stopLoader();
        loading = false;
      }
    );
  }


  opens(content, item, val) {
    this.resumeId = item;
    this.checkisDefault = val

    if (val == true) {
      Swal.fire({
        position: "center",
        icon: "info",
        title: "you can't edit the primary resume change the primary before you try to edit",
        showConfirmButton: false,
        timer: 3000,
      })
    } else {
      this.modalRef2 = this.modalService.show(content, this.backdropConfig);

    }
  }




  deleteResumes(id: any) {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-success',
        cancelButton: 'btn btn-danger'
      },
      buttonsStyling: false
    })
    swalWithBootstrapButtons.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        this.api.updatePut('candidates/deleteResumes/' + id, this.candidateDetails).pipe(takeUntil(this.destroy$)).subscribe(res => {
          if (res.code == "00000") {
            this.util.startLoader();
            Swal.fire({
              position: 'center',
              icon: 'success',
              title: 'Deleted Sucessfully',
              showConfirmButton: false,
              timer: 1500
            })
          }
          this.resumelist = res.data.candidateData.resumes
          this.candidateDetails = res.data.candidateData
          this.util.stopLoader();
        })
      }
    })
      ;
  }

  editresumes() {
    if (this.resumeupload != null && this.resumeupload != '' && this.resumeId != null) {
      this.util.startLoader()
      if (this.photoId != null) {
        this.candidateDetails.photo = this.photoId;
      } else {
        this.candidateDetails.photo = this.candidateDetails.photo;
      }
      this.FormData = new FormData();
      this.FormData.append("resume", this.resumeupload);
      this.candidateDetails.resumeFileId = this.resumeId

      this.candidateDetails.candidateReferenceId = this.candidateDetails.candidateId;
      if (localStorage.getItem('MemberShipType') !== 'Free') {
        (this.candidateDetails as any).businessId = localStorage.getItem('myBusinessId') || null;
      }
      this.FormData.append("candidate", new Blob([JSON.stringify(this.candidateDetails)], { type: "application/json" }));
      this.api.updatePut('candidates/updateCandidate', this.FormData).pipe(takeUntil(this.destroy$)).subscribe(res => {
        if (res.code == "00000") {
          this.util.stopLoader();
          this.modalRef2.hide();
          this.resumelist = res.data.candidateData.resumes
          this.candidateDetails = res.data.candidateData;
          console.log("After updated ", this.candidateDetails);
          this.candidateListing.emit({ content: "RESUME_UPLOADED", data: this.candidateDetails });
          this.resumeupload = ""
          this.fileDragdrop = ""
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Resumes updated successfully",
            showConfirmButton: false,
            timer: 2000,
          })
        }
      });

    }
    if (this.resumeupload != null && this.resumeId == null) {
      this.util.startLoader()
      if (this.photoId != null) {
        this.candidateDetails.photo = this.photoId;
      } else {
        this.candidateDetails.photo = this.candidateDetails.photo;
      }

      this.candidateDetails.candidateReferenceId = this.candidateDetails.candidateId;
      (this.candidateDetails as any).businessId = localStorage.getItem('myBusinessId') || null;

      this.FormData = new FormData();
      this.FormData.append("resume", this.resumeupload);
      this.FormData.append("candidate", new Blob([JSON.stringify(this.candidateDetails)], { type: "application/json" }));
      this.api.updatePut('candidates/updateCandidate', this.FormData).pipe(takeUntil(this.destroy$)).subscribe(res => {
        if (res.code == "00000") {
          this.util.stopLoader();
          this.modalRef.hide();
          this.resumelist = res.data.candidateData.resumes;
          this.candidateDetails = res.data.candidateData;
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Resumes Attached successfully",
            showConfirmButton: false,
            timer: 2000,
          })
        }
      });

    }

  }



  async downloadResume(data, loggedInUserId, fileId, fileName?) {
    const { candidateId, createdBy, connectionStatus,
      user, resumeDownloaded, ...rest } = data;
    // Always run the strip helper first — the template typically passes
    // the backend's UUID-prefixed `resume.fileName`, and the previous
    // `fileName || resolve…` order let that raw value through and the
    // saved file kept the `<uuid>_` prefix. Resolve from `data.resumes`
    // first (always stripped), fall back to the passed-in name.
    const resolvedFileName = this.resolveResumeFileName(data, fileId) || fileName || '';

    if (!resumeDownloaded && createdBy != this.userId) {
      const userData = await this.planService.UPDATE_USERDETAILS("ACTIVE_INTERACTIONS");
      let { membershipType } = userData;
      let availablePoints = null;
      let actualPoints = null;
      let utilizedPoints = null;
      let promotional = null;
      userData.userDetail.userPlanAndBenefits.benefitsUsages.forEach(ele => {
        if (ele.benefitKey == 'ACTIVE_INTERACTIONS') {
          availablePoints = ele.available
          actualPoints = ele.actual
          utilizedPoints = ele.utilized
          promotional = ele.promotional
        }
      });

      if (userData.isExpired) {
        let popupType: "PAY" | "LIMIT" | "UPGRADE" = "PAY";

        if (['Starter', 'Growth', 'ScaleX'].includes(membershipType)) {
          popupType = "LIMIT";
        }
        this.planService.expiredPopup("ACTIVE_INTERACTIONS", popupType, null, null, null, null, availablePoints, actualPoints, utilizedPoints, promotional);
        return;
      }
      else {
        this.afterPlanValidationDownloadResume(candidateId, this.userId, createdBy, fileId, resolvedFileName);
      }
    }
    else if (resumeDownloaded || createdBy === this.userId) {
      this.afterPlanValidationDownloadResume(candidateId, this.userId, createdBy, fileId, resolvedFileName);
    }
  }

  /** Recover the resume's original on-disk name (the backend stores it as
   *  `<uuid>_<originalFilename>.<ext>`). The download must keep the real
   *  extension — without it the saved file opens as plain text. */
  private resolveResumeFileName(data: any, fileId: any): string {
    const list = Array.isArray(data?.resumes) ? data.resumes : [];
    const match = list.find((r: any) => r?.fileId === fileId) || list[0];
    return this.stripResumeIdPrefix((match?.fileName ?? match?.name) || '');
  }

  // Backend stores resumes as `<uuid>_<original name>`; never surface the uuid to users.
  stripResumeIdPrefix(fileName: any): string {
    const raw = (fileName || '').toString().trim();
    if (!raw) return '';
    const uuidPrefix = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}_/;
    return uuidPrefix.test(raw) ? raw.replace(uuidPrefix, '').trim() : raw;
  }

  afterPlanValidationDownloadResume(candidateId, requestingUserId, createdBy, fileId, fileName?) {
    const endpoint = `candidates/resumeDownload/${candidateId}/${requestingUserId}/${createdBy}/${fileId}`;
    this.api.queryBlob(endpoint).pipe(takeUntil(this.destroy$)).subscribe(res => {
      const blob = new Blob([res]);
      this.downloadFile(blob, fileName || 'resume.pdf');
    });
  }

  uploadPhotoHere() {
    this.myFileInput2.nativeElement.click();
  }

  fileChangeEvent(event, popupName): void {
    const checkSize = super.checkImageSize(event.target.files[0]);
    this.imageChangedEvent = event;
    const acceptedImageTypes = ['image/gif', 'image/jpeg', 'image/png'];
    if (checkSize > 10) {
      Swal.fire("", `${this.IMAGE_ERROR}`, "info");
      this.myFileInput2.nativeElement.value = null;
    }
    if (event.target.files && event.target.files[0]) {
      this.fileUploadName = event.target.files[0].name;
      this.myFileInput2.nativeElement.value;

      const numberOfFiles = event.target.files.length;
      for (let i = 0; i < numberOfFiles; i++) {
        const reader = new FileReader();
        reader.onload = (e: any) => {
          this.fileshow = e.target.result;
        };
        reader.readAsDataURL(event.target.files[0]);
      }


    }

    if (!acceptedImageTypes.includes(event.target.files[0].type)) {
      Swal.fire('', 'Please upload the correct file type   (Only .jpg, .png, .jpeg)', 'info');
      this.myFileInput2.nativeElement.value = "";
      this.modalRef.hide();
    } else {
      this.PopupServicevlaues(popupName);
    }

  }

  PopupServicevlaues(template: TemplateRef<any>) {
    this.modalRef2 = this.modalService.show(template, {
      animated: true,
      backdrop: "static",
    });

  }

  cropperReady() {
    // cropper ready
  }

  loadImageFailed() {
    // show message
  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
    // console.log("this.v-- "+this.croppedImage.name);
    // console.log("this.croppedImage-- "+this.croppedImage);

    const byteString = window.atob(
      event.base64.replace(/^data:image\/(png|jpeg|jpg);base64,/, "")
    );
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([int8Array], { type: "image/jpeg" });

    this.fileToUpload = new File([blob], this.fileUploadName, {
      type: "image/jpeg",
    });
  }

  closePhoto2() {
    this.modalRef2.hide();
    this.photo = null;
    this.fileshow = undefined;
    this.myFileInput2.nativeElement.value = null;
    this.photoId = null;

  }

  imageLoaded2() {
    this.util.startLoader();
    const formData: FormData = new FormData();
    formData.append("file", this.fileToUpload, this.fileUploadName);
    // setTimeout(() => {
    this.api.create("upload/image", formData).pipe(takeUntil(this.destroy$)).subscribe((res) => {
      this.util.stopLoader();
      if (res) {
        this.photoId = res.fileId;
        this.img4.src = AppSettings.ServerUrl + "download/" + this.photoId;
        this.modalRef2.hide();

      }
    }, err => {
      this.util.stopLoader();

    });
  }

  BackBreadCream() {
    this._location.back();
  }

  LandingPage() {
    this.router.navigate(["landingPage"]);
  }
  getInitialstwo(firstname: string, lastname: string): string {
    return this.JobServicecolor.getInitialsparam(firstname, lastname);
  }

  getColortwo(firstname: string, lastname: string): string {
    return this.JobServicecolor.getColorparam(firstname, lastname);
  }

  getTextColor(firstname: string, lastname: string): string {
    return this.JobServicecolor.getTextColor(firstname, lastname);
  }

  // Blocks re-entry while a status change is in flight. checkUserPlanValid()
  // is a network round trip, so without this a second toggle click lands
  // before the first resolves and both reach expiredPopup() — showing the
  // "Not Enough Jobs / Candidate Slots" popup twice. Same pattern as
  // job.component.ts `isProcessingStatusChange`.
  isProcessingStatusChange: boolean = false;
  async enableCandidate(event) {
    if (this.isProcessingStatusChange) {
      // Undo the toggle the blocked click just flipped, so the switch keeps
      // showing the candidate's real state.
      const blocked = event.target as HTMLInputElement;
      blocked.checked = !blocked.checked;
      return;
    }
    this.isProcessingStatusChange = true;

    try {
      if (event.target.checked) {
        // Only check plan validation when enabling/activating a candidate
        const isPlanValid = await this.planService.checkUserPlanValid("JOB_CANDIDATE_POSTINGS" , "JOBS_CANDIDATES");
        if (isPlanValid) {
          this.afterPlanValidationstatuschange(event);
        } else {
          // If plan is invalid, reset the toggle to unchecked
          const input = event.target as HTMLInputElement;
          input.checked = false;
        }
      } else {
        // When disabling/deactivating a candidate, no plan validation needed
        this.afterPlanValidationstatuschange(event);
      }
    } finally {
      // Small tail so the rapid second click of a double-click is still caught
      // after the await resolves.
      setTimeout(() => {
        this.isProcessingStatusChange = false;
      }, 500);
    }
  }
  //open the candidate modal in job profile by monisha
  @ViewChild(CandidateTemplateComponent, { static: false }) CandidateTemplateComponent: CandidateTemplateComponent;
  async edit(item) {
    if (this.CandidateTemplateComponent) {
      this.CandidateTemplateComponent.opencandidateModal(item); // Open the modal
    }
  }
  // Public trigger methods — called from parent (new-candidate.component) via @ViewChild.
  // AUDIT_04 — null-guard on `candidateDetails?.candidateId` so the V3 persistent
  // header cannot fire an action before a candidate has loaded (NPE in `invite()`
  // / `edit()` when passed a null candidate).
  triggerInvite() {
    if (!this.candidateDetails?.candidateId) return;
    this.invite(this.candidateDetails, this.jobsupplyTemplateRef, this.connectionTemplate);
  }
  triggerEdit() {
    if (!this.candidateDetails?.candidateId) return;
    this.edit(this.candidateDetails);
  }
  triggerEnableCandidate(event: any) {
    if (!this.candidateDetails?.candidateId) return;
    this.enableCandidate(event);
  }
  triggerUploadResume() {
    if (!this.candidateDetails?.candidateId) return;
    this.model(this.candidateDetails, this.resumeUploadTemplateRef, 'null');
  }

  @Output() candidateReloadFromComponent = new EventEmitter<any>();
  @Output() candidateFilterFromComponent = new EventEmitter<any>();

  //event trigger in parent component by monisha
  oncandidateReload(event: any) {
    this.candidateReloadFromComponent.emit(event);
  }
  oncandidateFilterReload(event: any) {
    this.candidateFilterFromComponent.emit(event);
  }
  //jobseeker validation by monisha
  afterPlanValidationstatuschange(event) {
 
    if (this.userType == "JOB_SEEKER" && event.target.checked == true) {
    if (this.planService.JobSeekerUpdate.activeCandidatesCount >= 1) {
        event.preventDefault();
        this.util.stopLoader()
        // Undo the toggel from diable or off mode
        const input = event.target as HTMLInputElement;
        input.checked = false;
        Swal.fire({
          position: "center",
          icon: "info",
          title: "Number of profiles exceeded.",
          text: "You can't create more than 1 profile for yourself as a job seeker.",
          showConfirmButton: true,
          showCancelButton: false,
        });
      } else if (this.planService.JobSeekerUpdate.activeCandidatesCount < 1) {
        this.activatecanidates(event)
      }
    } else {
      this.activatecanidates(event)
    }
  } 
  
  activatecanidates(event) {
    const newStatus = event.target.checked ? 'ACTIVE' : 'INACTIVE';
    if (this.candidateDetails.status === newStatus) {
      return;
    }
    this.candidateDetails.status = newStatus;

    if (this.photoId != null) {
      this.candidateDetails.photo = this.photoId;
    } else {
      this.candidateDetails.photo = this.candidateDetails.photo;
    }
    this.FormData = new FormData();
    this.candidateDetails.candidateReferenceId = this.candidateDetails.candidateId;
    (this.candidateDetails as any).businessId = localStorage.getItem('myBusinessId') || null;
    // Only append resume if it's actually being uploaded (not null/empty)
    if (this.resumeupload != null && this.resumeupload !== '') {
      this.FormData.append("resume", this.resumeupload);
    }
    this.FormData.append("candidate", new Blob([JSON.stringify(this.candidateDetails)], { type: "application/json" }));
    this.resumeupload = "";

    this.util.startLoader()
    this.api.updatePut('candidates/updateCandidate', this.FormData).pipe(takeUntil(this.destroy$)).subscribe(res => {
      if (res.code == '00000') {
        this.commonValues.setCandidateData(this.candidateDetails);
        this.candidateDetails = res.data.candidateData;
        this.candidateListing.emit({
          content: "STATUS_UPDATED",
          data: res.data.candidateData
        });
        this.util.stopLoader();
        Swal.fire({
          icon: "success",
          title: "Candidate updated successfully",
          showDenyButton: false,
          showConfirmButton: false,
          timer: 2000,
        })
      }
    })
  }
  zipCodeValidaiton(x: number): boolean {
    if (String(x).length > 10) {
      return false;
    }
    return true;
  }


  onFileDropped(files: any) {
    console.log('Files dropped:', files);
    if (files && files.length > 0) {
      this.prepareFilesList(files);
    }
  }

  fileBrowseHandler(files: FileList) {
    console.log('Files browsed:', files);
    if (files && files.length > 0) {
      this.prepareFilesList(files);
    }
  }
  fileDragdrop: any = null;
  @ViewChild('fileDropRef') fileDropRef: ElementRef;
  prepareFilesList(files: Array<File> | FileList) {
    // Ensure we have a valid file
    if (!files || files.length === 0) {
      console.log('No files to process');
      return;
    }

    const file = files[0]; // Get the first file
    console.log('Processing file:', file);

    // Check file size
    if (file.size > this.fileSize) {
      Swal.fire("", `${this.IMAGE_ERROR}`, "info");
      if (this.fileDropRef && this.fileDropRef.nativeElement) {
        this.fileDropRef.nativeElement.value = '';
      }
      return;
    }

    // Define acceptable formats
    const acceptableFormats = [
      'application/pdf',
      'application/docx',
      'application/doc',
      'text/plain',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'application/msword'
    ];

    console.log('File type:', file.type);

    // Check if file type is acceptable
    if (acceptableFormats.includes(file.type)) {
      // Create a more robust file object with properties your template can display
      this.fileDragdrop = {
        file: file,
        fileName: file.name,
        fileSize: this.formatBytes(file.size),
        fileType: file.type
      };
      console.log('File accepted:', this.fileDragdrop);
      this.resumeupload = file;
    } else {
      console.log('Invalid file format');
      this.fileDragdrop = null;
      this.resumeupload = null;
      Swal.fire({
        icon: "info",
        title: "Please upload a valid format.",
        showDenyButton: false,
        timer: 3000,
      });
    }
  }

  removeFiles() {
    this.fileDragdrop = null;
    this.resumeupload = null;
    if (this.fileDropRef && this.fileDropRef.nativeElement) {
      this.fileDropRef.nativeElement.value = '';
    }
  }

  // Helper function to format bytes
  formatBytes(bytes: number, decimals: number = 2): string {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }


  onChangePeriod(value) {
  }

  getCandidateDetails() {
    this.api.query("candidates/findCandidateById/" + this.candidateDetails.candidateId).pipe(takeUntil(this.destroy$)).subscribe(res => {
      if (res.code == '00000') {
        this.util.stopLoader()
        this.resumelist = ""
        this.candidateDetails = res.data.candidateData
        this.resumelist = res.data.candidateData.resumes
        this.resumelength = res.data.candidateData.resumes
        this.candidateDetails.photo = res.data.candidateData.photo;
        // this.candidateDetails.userTypenot = res.data.candidateData.user.userType;
        this.photoId = res.data.candidateData.photo;
      }
    })
  }

  setPrimary(id, event) {
    this.util.startLoader();
    if (this.photoId != null) {
      this.candidateDetails.photo = this.photoId;
    } else {
      this.candidateDetails.photo = this.candidateDetails.photo;
    }
    this.FormData = new FormData();
    this.candidateDetails.primaryResumeId = id;
    this.candidateDetails.candidateReferenceId = this.candidateDetails.candidateId;
    (this.candidateDetails as any).businessId = localStorage.getItem('myBusinessId') || null;
    this.FormData.append("candidate", new Blob([JSON.stringify(this.candidateDetails)], { type: "application/json" }));
    this.api.updatePut('candidates/updateCandidate', this.FormData).pipe(takeUntil(this.destroy$)).subscribe(res => {
      if (res.code == "00000") {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Candidate updated successfully",
          showConfirmButton: false,
          timer: 2000,
        })
        this.resumelist = ""
        this.resumelist = res.data.candidateData.resumes
        this.candidateDetails = res.data.candidateData;
        this.util.stopLoader();
      }
    });



  }

  model(value, template: TemplateRef<any>, val) {
    this.resumeupload = "";
    this.fileDragdrop = "";
    this.util.startLoader();
    this.resumeId = val;
    let resume: Array<any> = value.resumes;
    if (resume == null || undefined || resume.length < 3) {
      this.modalRef2 = this.modalService.show(template, this.backdropConfig);
      setTimeout(() => {
        this.util.stopLoader();
      }, 500);
    } else if (resume.length >= 3) {
      this.util.stopLoader();
      Swal.fire(
        "You Already have 3 resumes, please delete and add another resume"
      );
    }
  }
  getFileName(name: string) {
    const index = name.indexOf('_');
    return index !== -1 ? name.substring(index + 1) : name;
  }

  getActiveUrgencyDays(candidate: any): number | null {
    if (!candidate?.isFeatured) return null;

    const now = new Date();
    let urgencyEndDate: Date;

    if (candidate?.featuredConsumptions?.length > 0) {
      const lastConsumption = candidate.featuredConsumptions[candidate.featuredConsumptions.length - 1];
      const fromDate = new Date(lastConsumption.fromDate);
      const dayCount = lastConsumption.dayCount || 1;
      urgencyEndDate = new Date(fromDate.getTime() + (dayCount * 24 * 60 * 60 * 1000));
    } else if (candidate?.featuredUpdatedOn) {
      const featuredDate = new Date(candidate.featuredUpdatedOn);
      urgencyEndDate = new Date(featuredDate.getTime() + (2 * 24 * 60 * 60 * 1000));
    } else {
      return 1;
    }

    const diffMs = urgencyEndDate.getTime() - now.getTime();
    const days = Math.ceil(diffMs / (1000 * 60 * 60 * 24));
    return days > 0 ? days : 1;
  }

}
